const actionType = {
    GET_ALL_DD_CONFIGURATION_SUCCESS: 'GET_ALL_DD_CONFIGURATION_SUCCESS',
    GET_DD_CONFIGURATION_SUCCESS: 'GET_DD_CONFIGURATION_SUCCESS',
    GET_ALL_DEFAULT_DICTIONARIES_SUCCESS: 'GET_ALL_DEFAULT_DICTIONARIES_SUCCESS',
};
export default actionType;